define((require) => {
    "use strict";

    var ImprovedView     = require("editor/zbone/ImprovedView"),
        Permissions      = require("shared/security/Permissions"),
        {isBlank}        = require("shared/util/StringUtils"),
        SystemMessages   = require("editor/services/SystemMessages"),
        template         = require("editor/ui/settings/fonts/ManageFontsDotComIntegrationView.tpl"),
        ValidateBehavior = require("ui/behaviors/ValidateBehavior");

    return ImprovedView.extend("ManageFontsDotComIntegrationView", {

        className: "tab-pane",

        template: template,

        templateHelpers: function() {
            return {
                permissionToManage: Permissions.Privileges.ADMIN.can()
            };
        },

        bindings: {
            ".jsFontsDotComAuthenticationKeyInput": {
                observe: "authenticationKey"
            }
        },

        behaviors: {
            validateBehavior: {
                behaviorClass: ValidateBehavior,
                inputValidation: {
                    ".jsFontsDotComAuthenticationKeyInput": {
                        validateAfter: "beforeSubmit",
                        // Mark as bound to model, so make sure we cancel pending save requests on error!
                        model: true,
                        validator: function(key) {
                            var re121hexadecimalsOrDashes = /^[0-9a-fA-F-]{121,121}$/;
                            return isBlank(key) || re121hexadecimalsOrDashes.test(key);
                        },
                        validatorAsync: {
                            "fontsDotCom:valid:key": {
                                source: SystemMessages,
                                validator: function(valid) {
                                    return valid;
                                }
                            }
                        },
                        errorText: function(/* value, type */) {
                            return "This is not a valid Fonts.com authentication key.";
                        }
                    }
                }
            }
        },

        active: function(state) {
            this.$el.toggleClass("active", state);
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/fonts/ManageFontsDotComIntegrationView.js